import React, { useMemo, useState, useRef, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

import axios from 'axios';

const MIN_HEIGHT = 500;
const MAX_HEIGHT = 700;

// import './style.scss';

const CommentList = props => {
  const {
    comments,
    configuration: {
      routes: {
        indexCommentPath,
      } = {},
      defaultRequestParams,
      commentBox: {
        minHeight: commentBoxMinHeight = MIN_HEIGHT,
        maxHeight: commentBoxMaxHeight = MAX_HEIGHT
      } = {}
    } = {},
    callbacks: {
      scrollDownContainer: callbackOnScrollDownContainer,
      setComments: callbackOnSetComments,
      orderComments: callbackOnOrderComments
    }
  } = props;

  const paginationRef = useRef({})

  // =================== START FETCH COMMENTS ===================

  const fetchService = async (page) => {

    let route = indexCommentPath({ ...defaultRequestParams, format: 'json' })

    let promise = axios.get(route, {
      method: 'get',
      headers: {
        "X-CSRF-TOKEN": window.compliance.token
      },
      params: { page: page }
    });

    return await promise;
  }

  const fetchComments = (page = 1) => {
    let _fetchService = fetchService(page);

    _fetchService.then(response => {
      let _comments = [...comments, ...response.data.comments];

      _comments = callbackOnOrderComments(_comments)

      paginationRef.current = {
        currentPage: response.data.current_page,
        inPage: response.data.in_page,
        total: response.data.total,
        totalPages: response.data.total_page,
      }

      callbackOnSetComments(_comments);

      if (page == 1 && _.isFunction(callbackOnScrollDownContainer)) {
        callbackOnScrollDownContainer();
      }

    }).catch(error => {
      console.log(error);
    })
  }

  useEffect(() => {
    fetchComments();
  }, [])

  // =================== END FETCH COMMENTS ===================

  const canViewMoreComments = useMemo(() => {
    return paginationRef.current.totalPages > paginationRef.current.currentPage;
  }, [paginationRef.current])

  const viewMoreCommentsButton = () => {
    if (canViewMoreComments) {
      return (
        <div
          className="text-center"
          onClick={() => {
            fetchComments(paginationRef.current.currentPage + 1)
          }}
        >
          Ver más comentarios...
        </div>
      )
    }
  }

  const commentList = () => {
    return (
      <Row>
        <Col md='12' id='comment-list-container'>
          {viewMoreCommentsButton()}
          {_.map(comments, comment => {
            return (
              <CommentItem
                key={comment.id}
                comment={comment}
                configuration={props?.configuration}
                currentUser={props?.data?.currentUser}
              />
            )
          })}
        </Col>
      </Row>
    )
  }

  return (
    <Row>
      <Col id='comment-box-container' style={{ minHeight: commentBoxMinHeight, maxHeight: commentBoxMaxHeight, overflowX: 'auto' }}>
        {commentList()}
      </Col>
    </Row>
  );
};

const CommentItem = props => {
  const {
    comment,
    configuration,
    currentUser
  } = props;

  const createdAtFormat = () => {
    return moment(comment.created_at).format('DD/MM/YYYY HH:mm:ss')
  }

  const isMyMessage = useMemo(() => {
    return comment.author_id === currentUser.id;
  }, [comment.author_id, currentUser.id]);

  return (
    <div className={`comment-card ${isMyMessage ? 'is-mine' : 'is-not-mine'} `}>
      <div className="message-card-container">
        <div className="card message-card">
          <p>{comment.body}</p>

          <span className="info-text">
            {`${comment.author_name} - ${createdAtFormat()}`}
          </span>
        </div>

        <div className="files-container">
          {_.map(comment.files, (file) => {
            return (
              <CommentFileItem
                comment={comment}
                file={file}
                key={`CommentFileItem-${file.id}`}
                configuration={configuration}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

const CommentFileItem = props => {
  const {
    file,
    comment,
    configuration: {
      routes = {},
      defaultRequestParams
    } = {}
  } = props;

  const downloadFileCommentPath = useMemo(() => {

    let request = { ...defaultRequestParams, attach_id: file.id, id: comment.id, _options: true }

    return routes.downloadFileCommentPath(request)
  })

  return (
    <a href={downloadFileCommentPath}
      className="badge badge-pill badge-light py-1 px-2 d-inline-block mr-2 mb-1"
      download={true}
    >
      <i className="fas fa-paperclip mr-2"></i>
      {file.filename}
    </a>
  );
}

export default CommentList;
